import type { Action } from 'state/actions';
import { addOrReplaceKey, removeKey } from 'state/utils/collection';

import type { SecondaryMarketCpOrderFormMap } from '../input/cpOrderInputForm.model';
import { initialCpOrderFormMap } from '../input/cpOrderInputForm.model';
import type { SecondaryMarketCpOrderReloadedForm } from './cpOrderOriginalForm.model';

export function originalFormReducer(
  state: SecondaryMarketCpOrderFormMap = initialCpOrderFormMap,
  action: Action,
): SecondaryMarketCpOrderFormMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_AMEND_CP_ORDER_FETCHED':
      return addOrReplaceKey(state, action.tabId, {
        client: action.data.client,
        comment: action.data.comment,
        clientType: action.data.clientType,
        custodian: action.data.custodian,
        salesDesk: undefined,
        cashAmount: action.data.cashAmount,
        quantity: action.data.quantity,
        salesId: action.data.salesId,
        salesMargin: action.data.salesMarginAdjusted,
        valuationDate: action.data.valuationDate,
        settlementDate: action.data.settlementDate,
        tradeWay: action.data.tradeWay,
        tradingPrice: action.data.tradingPriceAdjusted,
        upfront: undefined,
        tradeDateType: action.data.tradeDateType,
        settlementType: action.data.settlementType,
        etag: action.data.etag,
      } as SecondaryMarketCpOrderReloadedForm);
    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
      if (action.tabType === 'closePriceOrder') {
        return removeKey(state, action.tabId);
      }
      return state;
    default:
      return state;
  }
}
